// This list is also maintained in app/classes/country.rb
export default [
  {
    label: 'Afghanistan',
    value: 'Afghanistan',
    code: 'AF',
  },
  {
    label: 'Albania',
    value: 'Albania',
    code: 'AL',
  },
  {
    label: 'Algeria',
    value: 'Algeria',
    code: 'DZ',
  },
  {
    label: 'Andorra',
    value: 'Andorra',
    code: 'AD',
  },
  {
    label: 'Angola',
    value: 'Angola',
    code: 'AO',
  },
  {
    label: 'Antigua and Barbuda',
    value: 'Antigua and Barbuda',
    code: 'AG',
  },
  {
    label: 'Argentina',
    value: 'Argentina',
    code: 'AR',
  },
  {
    label: 'Armenia',
    value: 'Armenia',
    code: 'AM',
  },
  {
    label: 'Australia',
    value: 'Australia',
    code: 'AU',
  },
  {
    label: 'Austria',
    value: 'Austria',
    code: 'AT',
  },
  {
    label: 'Azerbaijan',
    value: 'Azerbaijan',
    code: 'AZ',
  },
  {
    label: 'Bahamas',
    value: 'Bahamas',
    code: 'BS',
  },
  {
    label: 'Bahrain',
    value: 'Bahrain',
    code: 'BH',
  },
  {
    label: 'Bangladesh',
    value: 'Bangladesh',
    code: 'BD',
  },
  {
    label: 'Barbados',
    value: 'Barbados',
    code: 'BB',
  },
  {
    label: 'Belarus',
    value: 'Belarus',
    code: 'BY',
  },
  {
    label: 'Belgium',
    value: 'Belgium',
    code: 'BE',
  },
  {
    label: 'Belize',
    value: 'Belize',
    code: 'BZ',
  },
  {
    label: 'Benin',
    value: 'Benin',
    code: 'BJ',
  },
  {
    label: 'Bhutan',
    value: 'Bhutan',
    code: 'BT',
  },
  {
    label: 'Bolivia',
    value: 'Bolivia',
    code: 'BO',
  },
  {
    label: 'Bosnia and Herzegovina',
    value: 'Bosnia and Herzegovina',
    code: 'BA',
  },
  {
    label: 'Botswana',
    value: 'Botswana',
    code: 'BW',
  },
  {
    label: 'Brazil',
    value: 'Brazil',
    code: 'BR',
  },
  {
    label: 'Brunei',
    value: 'Brunei',
    code: 'BN',
  },
  {
    label: 'Bulgaria',
    value: 'Bulgaria',
    code: 'BG',
  },
  {
    label: 'Burkina Faso',
    value: 'Burkina Faso',
    code: 'BF',
  },
  {
    label: 'Burundi',
    value: 'Burundi',
    code: 'BI',
  },
  {
    label: 'Cambodia',
    value: 'Cambodia',
    code: 'KH',
  },
  {
    label: 'Cameroon',
    value: 'Cameroon',
    code: 'CM',
  },
  {
    label: 'Canada',
    value: 'Canada',
    code: 'CA',
  },
  {
    label: 'Cape Verde',
    value: 'Cape Verde',
    code: 'CV',
  },
  {
    label: 'Central African Republic',
    value: 'Central African Republic',
    code: 'CF',
  },
  {
    label: 'Chad',
    value: 'Chad',
    code: 'TD',
  },
  {
    label: 'Chile',
    value: 'Chile',
    code: 'CL',
  },
  {
    label: 'China',
    value: 'China',
    code: 'CN',
  },
  {
    label: 'Colombia',
    value: 'Colombia',
    code: 'CO',
  },
  {
    label: 'Comoros',
    value: 'Comoros',
    code: 'KM',
  },
  {
    label: 'Congo, Democratic Republic of the',
    value: 'Congo, Democratic Republic of the',
    code: 'CD',
  },
  {
    label: 'Congo, Republic of the',
    value: 'Congo, Republic of the',
    code: 'CG',
  },
  {
    label: 'Costa Rica',
    value: 'Costa Rica',
    code: 'CR',
  },
  {
    label: 'Croatia',
    value: 'Croatia',
    code: 'HR',
  },
  {
    label: 'Cuba',
    value: 'Cuba',
    code: 'CU',
  },
  {
    label: 'Cyprus',
    value: 'Cyprus',
    code: 'CY',
  },
  {
    label: 'Czech Republic',
    value: 'Czech Republic',
    code: 'CZ',
  },
  {
    label: 'C\u00f4te d\'Ivoire',
    value: 'C\u00f4te d\'Ivoire',
    code: 'CI',
  },
  {
    label: 'Denmark',
    value: 'Denmark',
    code: 'DK',
  },
  {
    label: 'Djibouti',
    value: 'Djibouti',
    code: 'DJ',
  },
  {
    label: 'Dominica',
    value: 'Dominica',
    code: 'DM',
  },
  {
    label: 'Dominican Republic',
    value: 'Dominican Republic',
    code: 'DO',
  },
  {
    label: 'East Timor',
    value: 'East Timor',
    code: 'TL',
  },
  {
    label: 'Ecuador',
    value: 'Ecuador',
    code: 'EC',
  },
  {
    label: 'Egypt',
    value: 'Egypt',
    code: 'EG',
  },
  {
    label: 'El Salvador',
    value: 'El Salvador',
    code: 'SV',
  },
  {
    label: 'Equatorial Guinea',
    value: 'Equatorial Guinea',
    code: 'GQ',
  },
  {
    label: 'Eritrea',
    value: 'Eritrea',
    code: 'ER',
  },
  {
    label: 'Estonia',
    value: 'Estonia',
    code: 'EE',
  },
  {
    label: 'Ethiopia',
    value: 'Ethiopia',
    code: 'ET',
  },
  {
    label: 'Fiji',
    value: 'Fiji',
    code: 'FJ',
  },
  {
    label: 'Finland',
    value: 'Finland',
    code: 'FI',
  },
  {
    label: 'France',
    value: 'France',
    code: 'FR',
  },
  {
    label: 'Gabon',
    value: 'Gabon',
    code: 'GA',
  },
  {
    label: 'Gambia',
    value: 'Gambia',
    code: 'GM',
  },
  {
    label: 'Georgia',
    value: 'Georgia',
    code: 'GE',
  },
  {
    label: 'Germany',
    value: 'Germany',
    code: 'DE',
  },
  {
    label: 'Ghana',
    value: 'Ghana',
    code: 'GH',
  },
  {
    label: 'Greece',
    value: 'Greece',
    code: 'GR',
  },
  {
    label: 'Grenada',
    value: 'Grenada',
    code: 'GD',
  },
  {
    label: 'Guatemala',
    value: 'Guatemala',
    code: 'GT',
  },
  {
    label: 'Guinea',
    value: 'Guinea',
    code: 'GN',
  },
  {
    label: 'Guinea-Bissau',
    value: 'Guinea-Bissau',
    code: 'GW',
  },
  {
    label: 'Guyana',
    value: 'Guyana',
    code: 'GY',
  },
  {
    label: 'Haiti',
    value: 'Haiti',
    code: 'HT',
  },
  {
    label: 'Honduras',
    value: 'Honduras',
    code: 'HN',
  },
  {
    label: 'Hungary',
    value: 'Hungary',
    code: 'HU',
  },
  {
    label: 'Iceland',
    value: 'Iceland',
    code: 'IS',
  },
  {
    label: 'India',
    value: 'India',
    code: 'IN',
  },
  {
    label: 'Indonesia',
    value: 'Indonesia',
    code: 'ID',
  },
  {
    label: 'Iran',
    value: 'Iran',
    code: 'IR',
  },
  {
    label: 'Iraq',
    value: 'Iraq',
    code: 'IQ',
  },
  {
    label: 'Ireland',
    value: 'Ireland',
    code: 'IE',
  },
  {
    label: 'Israel',
    value: 'Israel',
    code: 'IL',
  },
  {
    label: 'Italy',
    value: 'Italy',
    code: 'IT',
  },
  {
    label: 'Jamaica',
    value: 'Jamaica',
    code: 'JM',
  },
  {
    label: 'Japan',
    value: 'Japan',
    code: 'JP',
  },
  {
    label: 'Jordan',
    value: 'Jordan',
    code: 'JO',
  },
  {
    label: 'Kazakhstan',
    value: 'Kazakhstan',
    code: 'KZ',
  },
  {
    label: 'Kenya',
    value: 'Kenya',
    code: 'KE',
  },
  {
    label: 'Kiribati',
    value: 'Kiribati',
    code: 'KI',
  },
  {
    label: 'Korea, North',
    value: 'Korea, North',
    code: 'KP',
  },
  {
    label: 'Korea, South',
    value: 'Korea, South',
    code: 'KR',
  },
  {
    label: 'Kuwait',
    value: 'Kuwait',
    code: 'KW',
  },
  {
    label: 'Kyrgyzstan',
    value: 'Kyrgyzstan',
    code: 'KG',
  },
  {
    label: 'Laos',
    value: 'Laos',
    code: 'LA',
  },
  {
    label: 'Latvia',
    value: 'Latvia',
    code: 'LV',
  },
  {
    label: 'Lebanon',
    value: 'Lebanon',
    code: 'LB',
  },
  {
    label: 'Lesotho',
    value: 'Lesotho',
    code: 'LS',
  },
  {
    label: 'Liberia',
    value: 'Liberia',
    code: 'LR',
  },
  {
    label: 'Libya',
    value: 'Libya',
    code: 'LY',
  },
  {
    label: 'Liechtenstein',
    value: 'Liechtenstein',
    code: 'LI',
  },
  {
    label: 'Lithuania',
    value: 'Lithuania',
    code: 'LT',
  },
  {
    label: 'Luxembourg',
    value: 'Luxembourg',
    code: 'LU',
  },
  {
    label: 'Macedonia',
    value: 'Macedonia',
    code: 'MK',
  },
  {
    label: 'Madagascar',
    value: 'Madagascar',
    code: 'MG',
  },
  {
    label: 'Malawi',
    value: 'Malawi',
    code: 'MW',
  },
  {
    label: 'Malaysia',
    value: 'Malaysia',
    code: 'MY',
  },
  {
    label: 'Maldives',
    value: 'Maldives',
    code: 'MV',
  },
  {
    label: 'Mali',
    value: 'Mali',
    code: 'ML',
  },
  {
    label: 'Malta',
    value: 'Malta',
    code: 'MT',
  },
  {
    label: 'Marshall Islands',
    value: 'Marshall Islands',
    code: 'MH',
  },
  {
    label: 'Mauritania',
    value: 'Mauritania',
    code: 'MR',
  },
  {
    label: 'Mauritius',
    value: 'Mauritius',
    code: 'MU',
  },
  {
    label: 'Mexico',
    value: 'Mexico',
    code: 'MX',
  },
  {
    label: 'Micronesia, Federated States of',
    value: 'Micronesia, Federated States of',
    code: 'FM',
  },
  {
    label: 'Moldova',
    value: 'Moldova',
    code: 'MD',
  },
  {
    label: 'Monaco',
    value: 'Monaco',
    code: 'MC',
  },
  {
    label: 'Mongolia',
    value: 'Mongolia',
    code: 'MN',
  },
  {
    label: 'Montenegro',
    value: 'Montenegro',
    code: 'ME',
  },
  {
    label: 'Morocco',
    value: 'Morocco',
    code: 'MA',
  },
  {
    label: 'Mozambique',
    value: 'Mozambique',
    code: 'MZ',
  },
  {
    label: 'Myanmar',
    value: 'Myanmar',
    code: 'MM',
  },
  {
    label: 'Namibia',
    value: 'Namibia',
    code: 'NA',
  },
  {
    label: 'Nauru',
    value: 'Nauru',
    code: 'NR',
  },
  {
    label: 'Nepal',
    value: 'Nepal',
    code: 'NP',
  },
  {
    label: 'Netherlands',
    value: 'Netherlands',
    code: 'NL',
  },
  {
    label: 'New Zealand',
    value: 'New Zealand',
    code: 'NZ',
  },
  {
    label: 'Nicaragua',
    value: 'Nicaragua',
    code: 'NI',
  },
  {
    label: 'Niger',
    value: 'Niger',
    code: 'NE',
  },
  {
    label: 'Nigeria',
    value: 'Nigeria',
    code: 'NG',
  },
  {
    label: 'Norway',
    value: 'Norway',
    code: 'NO',
  },
  {
    label: 'Oman',
    value: 'Oman',
    code: 'OM',
  },
  {
    label: 'Pakistan',
    value: 'Pakistan',
    code: 'PK',
  },
  {
    label: 'Palau',
    value: 'Palau',
    code: 'PW',
  },
  {
    label: 'Panama',
    value: 'Panama',
    code: 'PA',
  },
  {
    label: 'Papua New Guinea',
    value: 'Papua New Guinea',
    code: 'PG',
  },
  {
    label: 'Paraguay',
    value: 'Paraguay',
    code: 'PY',
  },
  {
    label: 'Peru',
    value: 'Peru',
    code: 'PE',
  },
  {
    label: 'Philippines',
    value: 'Philippines',
    code: 'PH',
  },
  {
    label: 'Poland',
    value: 'Poland',
    code: 'PL',
  },
  {
    label: 'Portugal',
    value: 'Portugal',
    code: 'PT',
  },
  {
    label: 'Qatar',
    value: 'Qatar',
    code: 'QA',
  },
  {
    label: 'Romania',
    value: 'Romania',
    code: 'RO',
  },
  {
    label: 'Russia',
    value: 'Russia',
    code: 'RU',
  },
  {
    label: 'Rwanda',
    value: 'Rwanda',
    code: 'RW',
  },
  {
    label: 'Saint Kitts and Nevis',
    value: 'Saint Kitts and Nevis',
    code: 'KN',
  },
  {
    label: 'Saint Lucia',
    value: 'Saint Lucia',
    code: 'LC',
  },
  {
    label: 'Saint Vincent and the Grenadines',
    value: 'Saint Vincent and the Grenadines',
    code: 'VC',
  },
  {
    label: 'Samoa',
    value: 'Samoa',
    code: 'WS',
  },
  {
    label: 'San Marino',
    value: 'San Marino',
    code: 'SM',
  },
  {
    label: 'Saudi Arabia',
    value: 'Saudi Arabia',
    code: 'SA',
  },
  {
    label: 'Senegal',
    value: 'Senegal',
    code: 'SN',
  },
  {
    label: 'Serbia',
    value: 'Serbia',
    code: 'RS',
  },
  {
    label: 'Seychelles',
    value: 'Seychelles',
    code: 'SC',
  },
  {
    label: 'Sierra Leone',
    value: 'Sierra Leone',
    code: 'SL',
  },
  {
    label: 'Singapore',
    value: 'Singapore',
    code: 'SG',
  },
  {
    label: 'Slovakia',
    value: 'Slovakia',
    code: 'SK',
  },
  {
    label: 'Slovenia',
    value: 'Slovenia',
    code: 'SI',
  },
  {
    label: 'Solomon Islands',
    value: 'Solomon Islands',
    code: 'SB',
  },
  {
    label: 'Somalia',
    value: 'Somalia',
    code: 'SO',
  },
  {
    label: 'South Africa',
    value: 'South Africa',
    code: 'ZA',
  },
  {
    label: 'South Sudan',
    value: 'South Sudan',
    code: 'SS',
  },
  {
    label: 'Spain',
    value: 'Spain',
    code: 'ES',
  },
  {
    label: 'Sri Lanka',
    value: 'Sri Lanka',
    code: 'LK',
  },
  {
    label: 'Sudan',
    value: 'Sudan',
    code: 'SD',
  },
  {
    label: 'Suriname',
    value: 'Suriname',
    code: 'SR',
  },
  {
    label: 'Swaziland',
    value: 'Swaziland',
    code: 'SZ',
  },
  {
    label: 'Sweden',
    value: 'Sweden',
    code: 'SE',
  },
  {
    label: 'Switzerland',
    value: 'Switzerland',
    code: 'CH',
  },
  {
    label: 'Syria',
    value: 'Syria',
    code: 'SY',
  },
  {
    label: 'S\u00e3o Tom\u00e9 and Pr\u00edncipe',
    value: 'S\u00e3o Tom\u00e9 and Pr\u00edncipe',
    code: 'ST',
  },
  {
    label: 'Tajikistan',
    value: 'Tajikistan',
    code: 'TJ',
  },
  {
    label: 'Tanzania',
    value: 'Tanzania',
    code: 'TZ',
  },
  {
    label: 'Thailand',
    value: 'Thailand',
    code: 'TH',
  },
  {
    label: 'Togo',
    value: 'Togo',
    code: 'TG',
  },
  {
    label: 'Tonga',
    value: 'Tonga',
    code: 'TO',
  },
  {
    label: 'Trinidad and Tobago',
    value: 'Trinidad and Tobago',
    code: 'TT',
  },
  {
    label: 'Tunisia',
    value: 'Tunisia',
    code: 'TN',
  },
  {
    label: 'Turkey',
    value: 'Turkey',
    code: 'TR',
  },
  {
    label: 'Turkmenistan',
    value: 'Turkmenistan',
    code: 'TM',
  },
  {
    label: 'Tuvalu',
    value: 'Tuvalu',
    code: 'TV',
  },
  {
    label: 'Uganda',
    value: 'Uganda',
    code: 'UG',
  },
  {
    label: 'Ukraine',
    value: 'Ukraine',
    code: 'UA',
  },
  {
    label: 'United Arab Emirates',
    value: 'United Arab Emirates',
    code: 'AE',
  },
  {
    label: 'United Kingdom',
    value: 'United Kingdom',
    code: 'GB',
  },
  {
    label: 'United States',
    value: 'United States',
    code: 'US',
  },
  {
    label: 'Uruguay',
    value: 'Uruguay',
    code: 'UY',
  },
  {
    label: 'Uzbekistan',
    value: 'Uzbekistan',
    code: 'UZ',
  },
  {
    label: 'Vanuatu',
    value: 'Vanuatu',
    code: 'VU',
  },
  {
    label: 'Vatican City',
    value: 'Vatican City',
    code: 'VA',
  },
  {
    label: 'Venezuela',
    value: 'Venezuela',
    code: 'VE',
  },
  {
    label: 'Vietnam',
    value: 'Vietnam',
    code: 'VN',
  },
  {
    label: 'Yemen',
    value: 'Yemen',
    code: 'YE',
  },
  {
    label: 'Zambia',
    value: 'Zambia',
    code: 'ZM',
  },
  {
    label: 'Zimbabwe',
    value: 'Zimbabwe',
    code: 'ZW',
  },
];
